  export const equipmentDocs = () =>
  [
    {
      label: "Παραστατικό Πώλησης",
      fileCode: 'INVOICE',
      id: 'INVOICE',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: "Δελτίο Αποστολής",
      fileCode: 'SHIPMENT',
      id: 'SHIPMENT',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: " Άλλο Έγγραφο",
      fileCode: 'OTHER',
      id: 'OTHER',
      multiple: false,
      fileLimit: 10
    },
  ].filter(item => item);